var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFelicitations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350.2 178.3",
    style: {
      enableBackground: "new 0 0 350.2 178.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#808993;}\r\n\t.st1{fill:#17243F;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:#21BBEE;}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.4,25c2-1.5,2.6-4.7,0.2-5.4L275.8,0c-0.2,0-0.3,0-0.5,0l-0.3,0.9L15.5,41.3c-1.9,0.3,2.6,4.8,2.8,5.9 l12.4,48.5l-13.2,9.1l0.5,3c0.2,1.1,1.8,1.8,3.7,1.5l261.8-39.2c1.5-0.2,3-0.8,4.3-1.6C287.8,68.5,335,35.1,348.4,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.3,22.9c2-1.4,1.5-3.2-0.9-3.9l-71.2-19c-0.2,0-0.3,0-0.5,0l-263,39.5c-1.9,0.3-3.3,1.3-3.1,2.4 l9.2,61.6c0.2,1,1.8,1.7,3.7,1.4l260.8-39.1c1.5-0.2,3-0.7,4.3-1.6C286.6,64.3,333.9,32.5,347.3,22.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.9709,
    y1: 108.0297,
    x2: 253.5309,
    y2: 82.1597,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.6,76.6c0,0-10.6,13.7,1.5,27.5l4.6-0.4c0,0-8.8-14.1-4.9-25.4c0.9,0,1.7,0.1,2.6,0.2 c1.1,0.1,2.5,0.1,3.3-0.7c0.4-0.5,0.7-1.1,0.9-1.8c0.4-1.2,0.6-2.5,0.4-3.7c-0.6,0.6-1.2,1.3-1.7,2c-0.4,0.6-0.6,1.3-1.2,1.8 c-1,0.7-2.5,0.4-3.6,0.5C255.1,76.6,253.7,76.4,253.6,76.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.4,
    y1: 21.785,
    x2: 275.5311,
    y2: 21.785,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.4,143.4c0,0,8.6,18.8,13.2,26.6c0,0,0.9,4.9,0,6.4l-0.8,0.3l3.6-0.1c0,0,0.3-6.6,0.1-7 c-0.2-0.2-0.5-0.4-0.8-0.4c0,0-1.5-12.1-6-14.7l-4.3-14.8L259.4,143.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.3,177.6c0,0.1,2.8,0,4.3,0c0.6,0,1-0.4,1.1-0.9l1.1-6c0.1-0.6-0.3-1.1-0.8-1.3l-0.6-0.1 c-0.5,0.7-0.7,1.6-0.6,2.4c0.3,1.2,0.5,4.2-0.2,4.6c-0.9,0.3-1.9,0.4-2.8,0.4C271.8,176.7,270.3,176.9,270.3,177.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.2,177.8c-0.2,0.1-0.2,0.3-0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c2.5,0,8.2-0.1,8.7-0.3 c0.7-0.3-0.2-2.6-1.2-3.4l-5.2,1.7L251.2,177.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.62,
    y1: 20.565,
    x2: 258.96,
    y2: 20.565,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249.6,142.1c0,0,5.6,27,7.1,32.2l-3.8,2.3c0,0,1.9-0.3,3.2-0.4c1.1-0.2,2-0.8,2.7-1.7l-0.5-0.7 c0,0-1.4-26.8-1.1-29.9L249.6,142.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.3185,
    y1: 61.5627,
    x2: 227.5585,
    y2: 108.0127,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.4,82.6c0,0-1.5,12.7,11.2,19.9l-2.3,8.3c0,0-11.6-7-11.1-26.1c0-0.5-0.2-1.1-0.5-1.5l-2.5-2.8 c-1-1.1-1.3-2.6-0.9-4l0.3-1.3c0.1-0.4,0.5-0.6,0.8-0.5c0.1,0,0.1,0,0.2,0.1l0.3,0.2c0.8,0.5,1.5,1.2,1.9,2.1l1.2,2.7 c0.5,1,1.5,1.6,2.6,1.5l0.8-0.1L239.4,82.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.3,99.4c2.1,0.6,9.4,2.5,13.9,2.4l-2.8,15.7l0.2,2.6h-9.1c-1.3-3.1-2.8-6-4.6-8.9 c-0.6-0.8-0.1-1.9,0.2-2.8l-0.5-0.3c-0.5-0.3-0.7-0.9-0.5-1.4l2.2-6.7C246.6,99.5,247,99.3,247.3,99.4 C247.3,99.4,247.3,99.4,247.3,99.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M248.9,118.6l0.2,1.6c0,0-2.6,7.7,1.3,25.5c0,0,8.3,2.4,15.1-3.3c0,0-1.9-16.9-2.5-17.7 c-2.6-3.9-4.4-4.8-4.4-4.8l-0.1-1.7C258.6,118.3,251.3,119.7,248.9,118.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.45,
    y1: 81.6578,
    x2: 258.16,
    y2: 81.6578,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.4,100.7l1.9-5.8l2.8,0.2l1.1,6.5C258.2,101.6,253.9,102.5,252.4,100.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.5305,
    y1: 89.0476,
    x2: 303.1305,
    y2: 86.2276,
    gradientTransform: "matrix(1 0 0 -1 0 180)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M256.4,85.8c-0.2,0.1-5.9,2.5-4.7,8.4c0.1,0.4,0.3,0.6,0.6,0.8c1.5,0.7,3.1,0.9,4.8,0.8c3-0.3,4.9-5.5,4.9-7 S258.2,84.6,256.4,85.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M258.2,83.5c-0.1,0-3.3,1.1-1.7,3.4c1.6,2.3,2.1,3.6,1.4,4.6s-2.2,0.4-2,2.3c0,0.4-0.1,0.8-0.5,1c-1.4,1-4.8,3.9-1.4,8 c0.3,0.3,0.3,0.8,0.1,1.2c-1,1.8-3.1,7,4.5,9.9s10.1-2,10.9-4c0.2-0.4,0.6-0.7,1-0.7c0.8,0,2-0.1,1.9-1.2 c-0.1-0.7-0.4-1.3-0.9-1.7c-0.4-0.4-0.5-1-0.1-1.4c0.1-0.1,0.2-0.2,0.3-0.2c0.5-0.3,0.9-0.7,1-1.3c0.5-1.7-0.5-6.7-5.2-7.5 c-0.4-0.1-0.8-0.4-0.9-0.8l0,0c-0.1-0.4,0.1-0.8,0.4-1c1.2-0.7,1.6-2.3,1-3.5c-0.6-1.3-1.7-2.1-3.1-2.3c-0.5-0.1-0.9-0.6-0.9-1.1 c0,0,0-0.1,0-0.1C264.2,85.3,264,82.7,258.2,83.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.1,95.2l-7.6,3.5l-5.9,2.7l-6.6,3l-4.7,2.2l-5,2.3l-3.6,1.7l-3.8,1.8l-2.9,1.3l-3.3,1.5l-2.2,1l-3.3,1.5 c-0.5,0.2-1.1-0.1-1.3-0.6c-0.1-0.2-0.1-0.4,0-0.6l1.5-3.3l1-2.2l1.5-3.3l1.3-2.8l1.7-3.7l1.7-3.6l2.3-5l2.3-4.6l3.1-6.6l2.7-5.8 l3.7-7.9L50.1,95.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.9,115.3l-2.2,1c-0.6-0.4-1.1-0.9-1.6-1.4c-0.5-0.5-1-1-1.4-1.6l1-2.2c0.6,0.8,1.2,1.5,1.9,2.2 C5.3,114,6,114.7,6.9,115.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M13,112.4l-2.9,1.3C9,112.9,7.9,112,6.9,111c-1-1-1.9-2.1-2.7-3.2l1.3-2.8c1,1.5,2.1,2.9,3.3,4.1 C10.1,110.3,11.5,111.4,13,112.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M20.3,109l-3.6,1.7c-3.8-2.4-7.1-5.6-9.5-9.5l1.7-3.6c1.3,2.4,3,4.6,4.9,6.5C15.7,106,17.9,107.7,20.3,109z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.5,98.7l-5.9,2.7c-4.4-2.1-8.3-5-11.7-8.5c-3.4-3.4-6.3-7.3-8.4-11.6l2.7-5.8c2.1,5.2,5.3,9.9,9.3,13.8 C32.5,93.4,37.2,96.6,42.5,98.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M30,104.5l-4.7,2.2c-2.9-1.7-5.6-3.7-8-6.1c-2.4-2.3-4.4-5-6.1-7.9l2.2-4.7c1.8,3.6,4.2,6.8,7,9.6 C23.2,100.4,26.4,102.7,30,104.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -46.5373 49.7997)",
    className: "st6",
    cx: 36.8,
    cy: 81.1,
    rx: 5.5,
    ry: 19.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87,49c-0.3-0.1-0.6-0.3-1.1-1.1c-0.3,0.3-0.5,0.6-0.6,1c0.3,0.5,0.8,0.8,1.3,1.1C86.6,49.6,86.8,49.3,87,49 z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.4,64.6c0.4,0.3,0.6,0.8,0.6,1.2c1.2-0.4,2.3-1.1,3.4-1.8c-0.1-0.6-0.3-1.1-0.7-1.5 C75.8,63.5,74.7,64.2,73.4,64.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.6,82.4c0.2-0.4,0.6-0.7,1.1-0.7c-0.4-0.5-0.9-1-1.4-1.3c-0.4,0.1-0.8,0.3-0.9,0.7 C105.9,81.4,106.3,81.9,106.6,82.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.2,95.5c0.5,0.5,1.1,0.7,1.8,0.7c0.1-1.1,0.5-2.2,1.2-3.2c-0.7-0.1-1.3-0.4-1.7-0.9 C55.8,93.1,55.3,94.3,55.2,95.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.2,30.4c-0.6,1.3-0.9,2.6-1,4c0.8,0.1,1.7-0.1,2.4-0.5c-0.1-0.9,0.1-1.7,0.6-2.4 C49.4,31.4,48.7,31,48.2,30.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M18.2,34.3c-0.2,1.2,0,2.4,0.5,3.5c0.7,0.1,1.5,0,2.1-0.3c-0.5-1.1-0.6-2.3-0.4-3.5 C19.7,34.5,18.9,34.6,18.2,34.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.7,40.4c0.2-0.2,0.4-0.3,0.6-0.4c-0.4-0.3-0.7-0.6-0.9-1c-0.2,0-0.5,0.1-0.6,0.3 C69.1,39.7,69.4,40,69.7,40.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.8,13.6c-0.7,0.6-1.6,1-3.8,1.1c0.2,1,0.7,1.9,1.4,2.6c1.4-0.1,2.8-0.7,4-1.5 C111.6,15.3,111.1,14.5,110.8,13.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.5,86.5c0.3,0.1,0.6,0.3,0.8,0.5c0.1-0.1,0.2-0.2,0.3-0.2c-0.2-0.3-0.5-0.5-0.8-0.7 C94.7,86.3,94.6,86.4,94.5,86.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.6,49.8c-0.1,0.5,0,1,0.4,1.3c0.7-0.4,1.6-0.7,2.4-0.7c-0.2-0.4-0.3-0.9-0.2-1.4 C42.3,49.1,41.4,49.3,40.6,49.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.4,59.5c0.9,0.1,1.7-0.2,2.4-0.8c-0.3-1.4-0.5-2.8-0.5-4.2c-0.4,0.2-0.9,0.2-1.4,0.2 C66,56.3,65.8,58,65.4,59.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.5,82.8c0.2,0.2,0.4,0.4,0.5,0.7c0.3-0.5,0.7-0.9,1.1-1.3c-0.1-0.3-0.2-0.5-0.4-0.7 C51.2,81.9,50.8,82.4,50.5,82.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.5,22.3c-0.8,0.1-1.6,0.4-2.2,1c0,0.6-0.1,1.2-0.3,1.7c0.5-0.2,0.9-0.1,1.6,0.4 C58.7,24.3,59.1,23.3,59.5,22.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41.7,85.1c0.1-0.5,0.3-0.9,0.7-1.2c-0.7-0.3-1.4-0.5-2.1-0.6c-0.2,0.4-0.3,0.8-0.2,1.3 C40.7,84.7,41.2,84.8,41.7,85.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.5,46.8c0,0.4,0.3,0.7,0.6,0.8c0.3-0.1,0.6-0.3,0.8-0.6c-0.2-0.4-0.3-0.9-0.2-1.3 C55.4,46.2,55,46.6,54.5,46.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.2,60.4c-0.1-0.5-0.5-0.9-1-1c-0.4,0.2-0.8,0.6-1,1c0.3,0.5,0.5,1.1,0.5,1.7 C49.1,61.5,49.6,60.9,50.2,60.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.4,88.9c-0.3,0-0.5,0.2-0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0,0.5-0.1,0.7-0.2 C60.7,89.4,60.5,89.2,60.4,88.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M70.9,47c0.2-0.4,0.3-0.9,0.3-1.3c-0.3,0-0.6,0-0.8,0.2c0,0.3,0,0.6-0.2,0.8C70.5,46.7,70.8,46.8,70.9,47z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.4,48.2c-0.3,0.2-0.7,0.4-1.1,0.3c0.3,0.5,0.6,1,1,1.5c0.3-0.2,0.6-0.4,0.8-0.7 C77.8,49,77.6,48.6,77.4,48.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.1,97.9c-0.1,0.2-0.1,0.5,0,0.7c0.2,0.1,0.5,0.1,0.7,0c0.1-0.3,0.2-0.6,0.4-0.8 C83.8,97.9,83.4,97.9,83.1,97.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.9,21.2c0.3-0.1,0.7-0.1,1,0.1c0.1-0.9,0.1-1.9,0-2.8c-0.4-0.1-0.8-0.2-1.2-0.1 C96,19.3,96.1,20.3,95.9,21.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33.7,34.3c0-0.3,0.1-0.7,0.2-0.9c-0.1,0-0.2-0.1-0.3-0.2c-0.2,0.3-0.3,0.6-0.4,1 C33.4,34.2,33.6,34.3,33.7,34.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.4,25.5c0.3,0,0.5,0,0.8-0.2c-0.4-0.8-0.6-1.6-0.7-2.4C38.2,23,38,23,37.7,22.9 C37.8,23.8,38,24.7,38.4,25.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.5,45.2c0.2,0.3,0.5,0.5,0.9,0.6c0.2-0.1,0.5-0.2,0.7-0.3c-0.2-0.1-0.3-0.3-0.2-0.7 C26.5,45,26,45.1,25.5,45.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.6,10.3c-0.7-0.3-1.4-0.3-2,0.1c-0.1,1.2-0.3,2.3-0.6,3.5c0.4,0,0.8,0,1.1,0.2 C64.3,12.7,64.9,11.4,65.6,10.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.5,38.7c-0.6,0.5-1,1.2-1.2,1.9c0.3,0.4,0.7,0.6,1.2,0.7c0.2-0.7,0.6-1.4,1.2-1.9 C39.1,39.4,38.7,39.1,38.5,38.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.6,60.5c0.5-0.3,0.9-0.6,1.3-1.1c-0.3-0.2-0.6-0.4-0.9-0.4c-0.2,0.3-0.4,0.5-0.8,0.7 C56.4,59.9,56.6,60.2,56.6,60.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.5,72.3c0.3,0.1,0.5,0.1,0.8,0c-0.1-0.3-0.1-0.5-0.1-0.8c-0.2-0.1-0.5-0.1-0.7-0.1 C28.6,71.7,28.6,72,28.5,72.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.1,24.6c0.2,0.6,0.2,1.3,0,1.9c1-0.1,2.1-0.4,3-0.9c-0.1-0.6-0.3-1.2-0.7-1.7 C72.7,24.4,71.9,24.6,71.1,24.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.2,17.8c-0.2,0.7,0.1,1.5,0.6,2c0.7,0,1.4-0.2,2-0.6c-0.1-0.9,0.1-1.8,0.5-2.6 C48.4,17.2,47.3,17.6,46.2,17.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.2,91.5c-0.6,0.1-0.9,0.5-1.4,1.1c1.5,1.2,2.7,2.7,3.6,4.4c0.4-0.4,0.9-0.7,1.5-0.8 C103.9,94.4,102.7,92.8,101.2,91.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.4,22.8c-0.1-1.1,0-2.2,0.5-3.1c-0.4,0-0.8-0.3-1-0.6c-0.6,1-0.9,2.2-0.9,3.4 C22.5,22.7,23,22.8,23.4,22.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.3,66.7c-0.2,0.4-0.5,0.8-0.9,1.1c0.9,0.3,1.7,0.8,2.5,1.4c0.4-0.2,0.8-0.6,1-1 C40,67.6,39.2,67.1,38.3,66.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.8,91.9c-0.5-0.1-1-0.4-1.2-0.8c-0.9,1.1-1.6,2.2-2.1,3.5c0.4,0.5,0.9,0.8,1.5,1 C79.3,94.2,79.9,93,80.8,91.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M64.6,71.9c0.5,0.6,0.7,1.4,0.5,3.2c0.8,0,1.6-0.4,2.3-0.9c0-1.2-0.2-2.4-0.8-3.4 C66,71.4,65.4,71.8,64.6,71.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.8,38.5c-0.1-0.4-0.4-0.7-0.7-0.8c-0.2,0.4-0.5,0.7-0.8,0.8c0.1,0.3,0.3,0.7,0.6,0.9 C86.1,39.1,86.5,38.8,86.8,38.5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.1,33.3c-0.5,0.3-0.8,0.8-0.8,1.3c0.7,0.5,1.3,1.2,1.9,1.8c0.1-0.3,0.3-0.5,0.6-0.6 C102.1,35,101.5,34.2,101.1,33.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.1,15.1c-0.7-0.5-1.5-0.7-2.4-0.5c-0.4,1.3-1,2.6-1.7,3.8c0.4,0.1,0.9,0.2,1.2,0.5 C83,17.6,83.9,16.3,85.1,15.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.1,75.1c-0.5,0.9-1.2,1.8-2,2.4c0.3,0.5,0.8,0.8,1.3,0.9c0.8-0.7,1.6-1.5,2.2-2.3 C35.8,75.9,35.4,75.7,35.1,75.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.5,48.7c0.2-0.5,0.3-1,0.3-1.6c-0.3,0-0.7,0.1-1,0.2c0.1,0.3,0,0.7-0.2,1C51,48.4,51.3,48.5,51.5,48.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M72.4,93c-0.8-1-1.7-1.8-2.7-2.4c-0.4,0.6-0.6,1.4-0.6,2.1c0.7,0.3,1.3,0.8,1.7,1.5 C71.1,93.6,71.7,93.1,72.4,93z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.8,71.4c-0.1-0.1-0.1-0.3-0.1-0.4c-0.4,0.1-0.8,0.2-1.1,0.4c0,0.2,0.1,0.3,0.2,0.5 C43.1,71.7,43.4,71.5,43.8,71.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M58.2,36.8c-0.2,0.2-0.2,0.6-0.1,0.8c0.3,0.1,0.6,0.2,0.8,0.1c0.1-0.4,0.3-0.7,0.6-0.9 C59.1,36.9,58.7,36.9,58.2,36.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.5,48.1c0.1,0.6,0.4,1.2,0.9,1.6c0.4,0,0.9,0,1.3,0.2c-0.2-0.4-0.1-0.7,0.2-1.2 C23,48.6,22.2,48.4,21.5,48.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M52.6,88.1c-0.1-0.3-0.2-0.6-0.5-0.8c-0.7,0.7-1.6,1.2-2.5,1.6c0.2,0.2,0.3,0.5,0.3,0.8 C50.9,89.3,51.8,88.8,52.6,88.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.7,37.3c0,0.4,0.1,0.8,0.3,1.1c0.3-0.3,0.7-0.4,1.2-0.5c0-0.4,0-0.8-0.2-1.1 C85.7,37.1,85.2,37.2,84.7,37.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M78.6,77.6l-1,0.4c0,0-1.6-2.7-2.9-3.1c-0.2-0.1-0.4-0.1-0.6,0l1-0.4C76.4,74.1,78.6,77.6,78.6,77.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.8,88.3c-0.2,0-0.4,0-0.5,0c1.1-1.6,0.4-7.4,2.9-8.7l0,0l0.1-0.1h0.1c0.1,0,0.2-0.1,0.4-0.1 C62.5,81.4,63.4,87.5,61.8,88.3L61.8,88.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.3,84.3c-0.2,0.1-0.4,0.1-0.6,0.1c1.3-1.8,0.1-8.8,1.3-9.4l0,0l0,0c0.2-0.1,0.4-0.1,0.6,0 C74,76.8,75,83.6,73.3,84.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.8,88.3l-1,0.4c-1.7,0.6-6.1-3.9-7.8-3.2l1-0.4c1.6-0.6,5.3,3,7.3,3.2C61.5,88.4,61.6,88.4,61.8,88.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.3,84.3l-1,0.4c-2.2,1-5.4-5.2-7.6-5.2c-0.1,0-0.3,0-0.4,0.1l1-0.4c2-0.7,5.1,5.1,7.4,5.2 C72.9,84.4,73.1,84.4,73.3,84.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49,78.9c-1.9,1.3-6.3-1.7-8.8-0.8l1-0.9c2.2-0.8,6.2,1.7,8.3,1c0.1,0,0.3-0.1,0.4-0.2l-0.7,0.6L49,78.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51,74.6c-1.1-0.5-2-1.3-2.7-2.3c-0.3-0.5-0.4-0.8-0.3-0.9C48.4,70.9,50.6,72.3,51,74.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.1,71.4c-0.8-0.5-1.5-1.1-2.1-1.9c-0.2-0.3-0.2-0.5-0.2-0.6l0,0C52.1,68.7,53.5,69.8,54.1,71.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.8,74.6L53.8,74.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c0.1-0.2,0.2-0.4,0.2-0.7 c0.1-0.7,0-1.4-0.3-2c0.4,0.2,0.9,0.4,1.3,0.6c0,0.2,0,0.3,0,0.5c0,0.3-0.1,0.6-0.3,0.9l0,0C54.1,74.3,53.9,74.4,53.8,74.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.7,71.8L57.7,71.8c-0.2,0.2-0.4,0.3-0.7,0.3c0.1-0.4,0.1-0.9,0-1.3l1-0.9C58.3,70.5,58.1,71.3,57.7,71.8z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50,78.1c-0.1,0.1-0.3,0.1-0.4,0.2l0.1-0.2c0.4-0.8,0.5-1.7,0.3-2.6c0.4,0.2,0.7,0.3,1.1,0.3 c-0.1,0.5-0.2,0.9-0.3,1.4c-0.1,0.2-0.2,0.4-0.3,0.6l0,0C50.3,77.9,50.2,78,50,78.1z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.7,71.8l-1,0.9c-0.7,0.4-1.5,0.5-2.2,0.2c-1.4-0.4-2.6-1.3-3.4-2.5c-0.2-0.4-0.2-0.6-0.2-0.6l1-0.9 c-0.1,0.1,0,0.2,0.2,0.6c0.5,0.8,1.2,1.4,2.1,1.9c0.9,0.6,1.9,0.8,2.9,0.7C57.2,72.1,57.5,72,57.7,71.8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.8,74.6l-1.1,0.9c-0.5,0.3-1,0.4-1.6,0.3c-0.4-0.1-0.7-0.2-1.1-0.3c-1.1-0.5-2-1.3-2.7-2.3 c-0.3-0.5-0.4-0.8-0.3-1l1-0.9c-0.1,0.1,0,0.4,0.3,0.9c0.7,1,1.6,1.8,2.7,2.3c0.7,0.3,1.4,0.4,2.1,0.3c0.1,0,0.2-0.1,0.3-0.1 C53.6,74.7,53.7,74.7,53.8,74.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.5,66.6l-0.6,2.2c-0.2,0.9-5.5-1.2-6.3,0.9l0.5-1.9c0.3-1.7,2.7-1.3,4.5-1.1 C31.6,66.8,32.4,66.9,32.5,66.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.5,66.6c-0.1,0.3-0.9,0.2-2,0.1c-1.2-1.5-2.8-3.3-2.5-4.3v-0.1c0.2-0.4,0.5-0.6,0.9-0.7 C30,63.4,32.7,65.9,32.5,66.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.5,57.5l-0.6,2.2c-0.4,1.5-3.3,1.2-4.9,1.8c-0.4,0.1-0.8,0.4-0.9,0.7l0.6-2.3c0.5-1.2,3.6-0.9,5.1-1.7 C34.1,58.2,34.4,57.9,34.5,57.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.5,57.5c-0.1,0.4-0.4,0.7-0.8,0.9c-0.7-1.6-2.6-3.4-2.2-6.3c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.7,0.4-1 C31.8,53.8,35,55.6,34.5,57.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.8,43.8l-0.6,2.2c0,0-4.4,0.6-6.1,4c-0.2,0.3-0.3,0.7-0.4,1l0.6-2.2C33.6,44.5,38.8,43.8,38.8,43.8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.2,24.9l-1.5,2.2c-2.6,2.1-5.4,3.7-8.5,4.9h-0.1c-0.4,0.2-0.8,0.4-1.1,0.8l1.4-2.1 c0.3-0.4,0.7-0.7,1.2-0.9C61.7,28.7,64.6,27,67.2,24.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.8,53.8L48.4,56l-0.1,0.2c-0.6,0.8-1.6,1-3,1.2l1.5-2.2c0.7-0.1,1.4-0.2,2-0.5 C49.2,54.5,49.6,54.2,49.8,53.8z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M49.8,53.8c-0.3,0.4-0.6,0.7-1.1,0.8c0-0.6,0-1.2-0.1-1.8c-0.3-1.9-1.3-3.5-0.3-5.2l0.1-0.1 c0.3-0.4,0.6-0.7,1-1c-0.2,1.3,0.5,2.6,0.7,4C50.4,52.2,50.3,53.2,49.8,53.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.2,39.6l-1.4,2.2l-0.1,0.2c-0.9,1.2-3.2,1.9-5.6,2.8c-1.3,0.4-2.5,1-3.6,1.8c-0.4,0.3-0.7,0.6-1,1 l1.5-2.2c0.6-0.9,2-1.9,4.6-2.8c1.5-0.5,3-1.1,4.5-1.8C59.5,40.4,59.9,40,60.2,39.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.2,39.6L60.2,39.6c-0.3,0.4-0.7,0.8-1.2,1c-0.4-2.1-4.2-5.6-3-7.6l0.1-0.1c0.3-0.4,0.7-0.6,1.1-0.8h0.1 c0.4,2.3,3.7,5.3,3.2,7C60.4,39.3,60.3,39.4,60.2,39.6z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.4,83.8l-3.3,0.2c-3.8-1.1-7.5-2.7-10.9-4.8l-0.1-0.1c-0.5-0.3-1-0.5-1.6-0.5l3.1-0.2 c0.6,0,1.2,0.2,1.8,0.5C125.8,81.1,129.5,82.8,133.4,83.8z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M92.6,87.4l-3.1,0.2h-0.2c-1.2,0-2.1-0.9-3.3-2.1l3.3-0.2c0.6,0.6,1.2,1.2,1.9,1.7 C91.5,87.2,92,87.4,92.6,87.4z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M92.6,87.4c-0.6,0-1.1-0.2-1.6-0.5c0.6-0.4,1.2-0.9,1.7-1.4c1.7-1.7,2.6-3.8,4.8-4h0.2 c0.6,0,1.2,0.1,1.7,0.2c-1.3,0.7-2.2,2.3-3.4,3.6C94.6,86.8,93.5,87.4,92.6,87.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114,87.4l-3.1,0.2h-0.3c-1.8,0-4.2-1.9-6.7-3.6c-1.4-1-2.8-1.7-4.4-2.3c-0.6-0.2-1.1-0.3-1.7-0.2l3.3-0.2 c1.4,0,3.3,0.6,6.1,2.5c1.6,1.2,3.3,2.2,5,3.1C112.7,87.3,113.3,87.4,114,87.4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114,87.4L114,87.4c-0.7,0-1.3-0.1-1.9-0.4c1.8-1.9,2.5-8.1,5.3-8.4h0.2c0.6,0,1.1,0.2,1.6,0.5l0.1,0.1 c-2,2-2.6,7.5-4.6,8.2C114.4,87.4,114.2,87.4,114,87.4z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M117.5,105.2c-0.7,0.7-1.6,1-3.8,1.1c0.2,1,0.7,1.9,1.4,2.6c1.4-0.1,2.8-0.7,4-1.5 C118.3,106.8,117.8,106,117.5,105.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M72.3,101.8c-0.7-0.3-1.4-0.3-2.1,0.1c-0.1,1.2-0.3,2.4-0.6,3.5c0.4,0,0.8,0,1.1,0.2 C71,104.2,71.6,102.9,72.3,101.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.9,104.3c-0.2,0.7,0.1,1.5,0.6,2c0.7,0,1.4-0.2,2-0.6c-0.1-0.9,0.1-1.8,0.5-2.7 C58.1,103.6,57,104.1,55.9,104.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.8,106.7c-0.7-0.5-1.5-0.7-2.4-0.5c-0.4,1.3-1,2.6-1.7,3.8c0.5,0.1,0.9,0.2,1.2,0.5 C89.7,109.1,90.7,107.8,91.8,106.7z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.8,62.2c-0.4-1.8,0-3.6,1-5.1c1-1.3,2.8-2.1,5.4-2.5l6.9-1.1l0.5,3.3l-6.9,1.1c-1.6,0-2.8,1.2-2.9,2.8 c0,0.3,0,0.6,0.1,0.9l0.4,2.9l8.8-1.3l0.5,3.3l-8.8,1.3l1.2,8.2l-4.2,0.6L82.8,62.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.3,72c-1.4-1.1-2.3-2.8-2.4-4.6l-1.2-7.8c-0.4-1.8,0-3.6,1-5.1c1-1.3,2.8-2.1,5.4-2.5l6.9-1l0.5,3.3 l-6.9,1.1c-0.9,0.1-1.7,0.5-2.3,1.1c-0.5,0.8-0.6,1.7-0.4,2.6l0.3,2.3L113,60l0.5,3.3l-8.8,1.3l0.3,2.3c0,1.6,1.3,2.8,2.8,2.9 c0.3,0,0.6,0,0.9-0.1l7-1.1l0.5,3.3l-7,1.1C106.6,73.2,104.7,72.9,103.3,72z M106.7,45.2l4-0.6l-2.6,5.2l-3.1,0.5L106.7,45.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.5,69.4c-1.4-1.1-2.2-2.8-2.4-4.6l-2.2-14.3l4.2-0.6l2.2,14.3c0.1,0.9,0.4,1.7,1.1,2.3 c0.7,0.5,1.5,0.6,2.3,0.4l6.6-1l0.5,3.3l-6.6,1C123.6,70.6,121.7,70.3,120.5,69.4z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.9,47.9l4.2-0.6l3.2,20.8l-4.2,0.6L132.9,47.9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.4,65.5c-1.8-1.2-2.9-3.2-3.1-5.3l-1-6.3c-0.5-2.1,0-4.3,1.3-6c1.3-1.5,3.3-2.5,6.1-2.9 c1.6-0.3,3.3-0.2,4.9,0.2c1.3,0.5,2.5,1.3,3.4,2.5l-2.7,2.5c-0.6-0.7-1.4-1.3-2.2-1.8c-0.9-0.3-1.9-0.4-2.9-0.2 c-1.2,0.1-2.4,0.7-3.2,1.6c-0.6,1-0.8,2.2-0.6,3.4l1,6.3c0.1,1.2,0.6,2.3,1.5,3.1c1,0.7,2.3,0.9,3.5,0.6c1.1-0.1,2.1-0.5,2.9-1.1 c0.7-0.7,1.3-1.5,1.6-2.4l3.3,1.7c-0.4,0.9-1,1.7-1.6,2.5c-0.6,0.7-1.4,1.2-2.2,1.6c-1.1,0.5-2.3,0.8-3.5,1 C150.2,66.9,148,66.6,146.4,65.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161,43.6l4.2-0.6l3.2,20.8l-4.2,0.6L161,43.6z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M175.1,44.8l-6.3,1l-0.5-3.3L185,40l0.5,3.3l-6.2,1l2.7,17.5l-4.2,0.6L175.1,44.8z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.4,54.1l-8.1,1.2l-0.6,5l-4.2,0.6l2.5-17.3c0.1-1,0.4-2,0.7-2.9c0.2-0.6,0.6-1.2,1.2-1.6 c0.6-0.4,1.3-0.6,2-0.7c0.7-0.1,1.4-0.1,2.1,0.1c0.6,0.2,1.2,0.6,1.6,1.2c0.6,0.8,1.2,1.7,1.6,2.6l7.6,15.8l-4.2,0.6L199.4,54.1z  M198,51.1l-3.8-8.1c-0.2-0.5-0.5-0.7-0.8-0.7s-0.5,0.3-0.5,0.9l-1.2,8.9L198,51.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.5,39.9l-6.3,1l-0.5-3.3l16.7-2.6l0.5,3.3l-6.3,1l2.7,17.5l-4.2,0.6L207.5,39.9z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.5,34.5l4.2-0.6l3.2,20.8l-4.2,0.6L220.5,34.5z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234,52.2c-1.7-1.2-2.8-3.2-3-5.3l-1-6.3c-0.5-2.1,0-4.3,1.3-6c1.3-1.5,3.3-2.5,6-2.9c2.8-0.4,4.9-0.1,6.6,1 c1.7,1.2,2.8,3.2,3,5.3l1,6.3c0.5,2.1,0,4.3-1.3,6c-1.2,1.5-3.3,2.5-6,2.9S235.6,53.2,234,52.2z M243.1,48.2 c0.7-1,0.9-2.2,0.6-3.4l-1-6.3c-0.1-2.2-1.9-3.9-4.1-3.8c-0.3,0-0.6,0.1-0.9,0.1c-2.2,0.1-3.9,1.9-3.8,4.1c0,0.3,0.1,0.6,0.1,0.9 l1,6.3c0.1,1.2,0.7,2.3,1.6,3c1,0.7,2.2,0.9,3.4,0.6C241.2,49.8,242.3,49.2,243.1,48.2L243.1,48.2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.1,27.5l2.4,15.9c0.3,1.3,0.1,2.6-0.4,3.8c-0.7,1-1.8,1.7-3,1.7l-2.9,0.5l-8.2-13.2l2.2,14.1l-3.9,0.6 L250,30.1l4.7-0.7l10.2,16h0.1c0.3,0,0.5-0.2,0.6-0.5c0.1-0.5,0.1-1.1-0.1-1.6l-2.3-15.2L267.1,27.5z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.8,46.9c-0.9-0.1-1.8-0.5-2.6-0.9c-0.9-0.5-1.6-1.2-2.4-1.9l2.5-2.8c0.8,0.8,1.7,1.5,2.7,2 c0.9,0.4,2,0.5,2.9,0.3c1.2-0.1,2.3-0.5,3.3-1.2c0.6-0.6,0.9-1.5,0.7-2.4c-0.1-0.5-0.3-0.9-0.7-1.2c-0.6-0.3-1.2-0.6-1.9-0.6 c-1.3-0.2-2.5-0.3-3.8-0.4c-1.6,0-3.2-0.5-4.5-1.5c-1.1-1-1.9-2.4-2-3.9c-0.2-1.1,0-2.3,0.4-3.4c0.5-1,1.3-1.9,2.3-2.5 c1.2-0.7,2.5-1.2,3.9-1.4c1.6-0.3,3.3-0.3,4.9,0.2c1.3,0.4,2.4,1.1,3.2,2.1l-2.4,2.7c-0.7-0.5-1.3-0.9-1.7-1.2 c-0.5-0.3-1-0.4-1.5-0.5c-0.6-0.1-1.3-0.1-1.9,0c-0.9,0.1-1.8,0.5-2.4,1.1c-0.5,0.7-0.7,1.5-0.5,2.4c0.1,0.8,0.6,1.5,1.4,1.7 c1,0.3,2,0.5,3,0.6c1.4,0,2.8,0.2,4.2,0.5c1,0.2,2,0.7,2.8,1.4c0.9,0.9,1.4,2,1.5,3.3c0.4,1.8-0.2,3.6-1.5,4.9 c-1.3,1.2-3.4,2.1-6.3,2.5C280.3,47.1,279.1,47.1,277.8,46.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.2,43c-0.5-0.3-0.9-0.9-0.9-1.5c-0.1-0.6,0.1-1.2,0.4-1.8c0.4-0.5,0.9-0.9,1.5-1 c0.6-0.1,1.2,0.1,1.7,0.5c0.5,0.4,0.8,0.9,0.9,1.5c0.1,0.6,0,1.2-0.4,1.7c-0.4,0.5-0.9,0.8-1.5,0.9 C303.4,43.5,302.7,43.4,302.2,43z M298.9,22.6l3.8-0.6l1.6,14.4l-2.7,0.4L298.9,22.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFelicitations);
export default __webpack_public_path__ + "static/media/felicitations.3441ba51f89b36d2f37c4e047a127911.svg";
export { ForwardRef as ReactComponent };